import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabaseModule, AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { environment } from '../../environments/environment';

import { HttpClientModule } from '@angular/common/http';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { HttpHeaders } from '@angular/common/http/src/headers';

import { StoreService } from './../store.service'

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
  provider = new firebase.auth.GoogleAuthProvider();
  constructor(
    private http : Http,
    public afAuth: AngularFireAuth,
    private db: AngularFireDatabase,
    private $store : StoreService
  ) { }


  ngOnInit() {
    this.provider.addScope('https://www.googleapis.com/auth/userinfo.profile');

    this.afAuth.authState.subscribe(user => {
      if (user) {
        if (user.email.endsWith('@converteo.com') || user.email === 'elise.patrikainen@gmail.com') {
          user.getIdToken().then(token => {
          this.$store.setToken(token)
          this.$store.getCurrentUser()
          })}
        else {
          alert('Not allowed')
          this.logout()
        }
        }})
    
  }

  authState: any = null;

  login() {
    this.afAuth.auth.signInWithPopup(this.provider)
      .then((credential) =>  {
        this.authState = credential.user
        this.updateUserData()
    })
    .catch(error => console.log(error));

  }

  private updateUserData(): void {
    // useful if your app displays information about users or for admin features
      let path = `users/${this.authState.uid}`; // Endpoint on firebase
      let data = {
                    email: this.authState.email,
                    name: this.authState.displayName, 
                    photoURL : this.authState.photoURL
                  }
      this.db.object(path).update(data)
      .catch(error => console.log(error));
  
    }

  logout() {
    this.afAuth.auth.signOut();
  }


}



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/landing-page/landing-page.component.ts